import useMarginClassNames from "src/hooks/useMarginClassnames";
import "./TextBubble.scss";
import classNames from "classnames";

interface IProps {
    text: string;
    tagText?: string;
    inline?: boolean;
    margin?: marginOrPadding;
}

const TextBubble = (props: IProps) => {
    const margins = useMarginClassNames(props.margin);
    
    return (
        <div className={classNames("TextBubble", { "TextBubble--inline": props.inline }, margins)}>
            {props.tagText && <span className="TextBubble__tag">{props.tagText}</span>}
            {props.text}
        </div>
    );
};

export default TextBubble;
